import { PURCHASE_OUTSTANDING_REPORT_FAILURE, PURCHASE_OUTSTANDING_REPORT_REQUEST, PURCHASE_OUTSTANDING_REPORT_SUCCESS } from "../types";
  
  const initialState = {
    purchaseOutstandingReport: {},
    loading: false,
    error: null,
  };
  
  const purchaseOutstandingReportReducer = (state = initialState, action) => {
    switch (action.type) {
      case PURCHASE_OUTSTANDING_REPORT_REQUEST: {
        return {
          ...state,
          loading: true,
          purchaseOutstandingReport: {},
          error: null
        };
      }
      case PURCHASE_OUTSTANDING_REPORT_SUCCESS: {
        return {
          ...state,
          purchaseOutstandingReport: {...(action.payload || {})},
          loading: false,
          error: null
        };
      }
      case PURCHASE_OUTSTANDING_REPORT_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        };
      }
      default:
        return state;
    }
  };
  
  export default purchaseOutstandingReportReducer;
  